import React, { useState } from "react";
import { Button, FormControl, InputLabel, MenuItem } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formSchemaregister } from "../../component/validation";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import Dropdown from "../../ui/Dropdown";

function Signup() {
  const navigate =useNavigate()
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },

    control,
  } = useForm({
    resolver: yupResolver(formSchemaregister),
  });

 

  const registerUser = async (formDataObj) => {
  const response = await axios.post(process.env.REACT_APP_API_URL+'register', formDataObj);
  return response.data;
};

const mutation = useMutation({
  mutationFn: registerUser,
  onSuccess: (data) => {


    localStorage.setItem("token", data.token);
    // localStorage.setItem("username", data.userdata.name);
  
   
    navigate("/");
  },
  onError: (error) => {
    console.error("Registration failed:", error);
    alert("Registration failed");
  },
});

  const onSubmit = async (data) => {


    const formDataObj = new FormData(); // Create FormData instance
    formDataObj.append("name", data.fullname);
    formDataObj.append("email", data.email);
    formDataObj.append("password", data.password);
    formDataObj.append("password_confirmation", data.password_confirmation);
    formDataObj.append("mobile", data.mobile);
    formDataObj.append("birth_date", data.birthdate);
    formDataObj.append("user_type_id", 2);
    formDataObj.append("gender_id", 1);
    // formDataObj.append("user_image", null);
    formSchemaregister
      .validate(data, { abortEarly: false })
      .then((validData) => {
        console.log("Valid!", validData);
        // Proceed to send validData to backend
      })
      .catch((validationError) => {
        console.log("notValid!", validationError);
      });
      mutation.mutate(formDataObj);

  };

  return (

      <div className="container" style={{ direction: t("directions.dir") }} >
        <h2 style={{ textAlign: "center", margin: "50px" }}>
          {t("SignUp.title")}
        </h2>

        <div
          style={{
            textAlign: "center",
            borderRadius: "8px",
            padding: "16px",
            border: "1px solid",
            width: "450px",
            boxshadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
            margin: "0 auto",
          }}
          className="row"
        >
          <div style={{ fontWeight: 300 }} className="col-md-12">
            {t("SignUp.welcome")}
          </div>
          <div
            className="col-md-12 mt-4"
            style={{ textAlign: t("directions.align") }}
          >
            <label for="date">{t("SignUp.fullname")}*</label>
          </div>
          <div className="col-md-12">
            <input
              {...register("fullname")}
              type="text"
              className="form-control"
              placeholder={t("SignUp.fullname")}
              autoComplete="off"
            />
            {errors.fullname && <p style={{ color: "red" }}>{errors.fullname.message}</p>}
          </div>

          <div
            className="col-md-12 mt-4"
            style={{ textAlign: t("directions.align") }}
          >
            <label for="date">{t("SignUp.mobile")}</label>
          </div>
          <div className="col-md-12">
            <input
             {...register("mobile")}
              type="text"
              className="form-control"
              placeholder={t("SignUp.mobile")}
              autoComplete="off"
              name="mobile"
              id="mobile"
           
            />
             {errors.mobile && <p style={{ color: "red" }}>{errors.mobile.message}</p>}
          </div>
          
          <div
            className="col-md-12 mt-4"
            style={{ textAlign: t("directions.align") }}
          >
            <label for="date">{t("SignUp.gender")}</label>
            <Controller
                    name="gender"
                    control={control}
                   
                    render={({ field, fieldState }) => (
                      <Dropdown
                       
                        url="genders"
                        value={field.value}
                        onChange={field.onChange}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                      />
                    )}
                  /></div>
          <div
            className="col-md-12 mt-4"
            style={{ textAlign: t("directions.align") }}
          >
            <label for="date">{t("SignUp.email")}</label>
          </div>
          <div className="col-md-12">
            <input
            {...register("email")}
              type="email"
              className="form-control"
              placeholder={t("SignUp.email")}
              autoComplete="off"
              name="email"
              id="email"

            />
          </div>
          <div
            className="col-md-12 mt-4"
            style={{ textAlign: t("directions.align") }}
          >
            <label for="date">{t("SignUp.birthdate")}</label>
          </div>
          <div className="col-md-12">
            <input
             {...register("birthdate")}
              type="date"
              className="form-control"
              placeholder={t("SignUp.birthdate")}
              autoComplete="off"
              name="birthdate"
              id="birthdate"
         
            />
          </div>
            
          <div
            className="col-md-12 mt-4"
            style={{ textAlign: t("directions.align") }}
          >
            <label for="date">{t("SignUp.password")}</label>
          </div>
          <div className="col-md-12">
            <input
             {...register("password")}
              id="password"
              name="password"
              type="password"
              className="form-control"
              placeholder={t("SignUp.password")}
              autoComplete="new-password"
      
            />
             {errors.password && <p style={{ color: "red" }}>{errors.password.message}</p>}
          </div>
          <div
            className="col-md-12 mt-4"
            style={{ textAlign: t("directions.align") }}
          >
            <label for="date">{t("SignUp.password2")}</label>
          </div>
          <div className="col-md-12">
            <input
             {...register("password_confirmation")}
              id="password_confirmation"
              name="password_confirmation"
              type="password"
              className="form-control"
              placeholder={t("SignUp.password2")}
              autoComplete="new-password"
          
            />
          </div>
          {errors.password_confirmation && <p style={{ color: "red" }}>{errors.password_confirmation.message}</p>}
          <div className="col-md-12 my-4">
            <Button
            type="submit"
              sx={{
                background: "#232324",
                color: "#fff",
                fontFamily: "Oswald, cairo",
                fontSize: "16px",
                fontWeight: 300,
              }}
              onClick={handleSubmit(onSubmit)}
            >
              {t("SignUp.buttontext")}
            </Button>
          </div>
        </div>
      </div>
 
  );
}

export default Signup;
